module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Latte_HK.b6305b18.png";